var map = {
	"./31.png": "1122",
	"./32.png": "1ba6",
	"./Ali.png": "097e",
	"./Ebay.png": "bd2e",
	"./Lazada.png": "d545",
	"./Shopee.png": "454f",
	"./Wayfair.png": "dbb2",
	"./background.png": "d079",
	"./background2.png": "1606",
	"./feiji.png": "294d",
	"./lotte.png": "90db",
	"./shopify.png": "c350",
	"./yamaxun.png": "462f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6826";